import script from "./SourceFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./SourceFilters.vue?vue&type=script&setup=true&lang=js"

import "./SourceFilters.vue?vue&type=style&index=0&id=24e39fe7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e39fe7"]])

export default __exports__